/**
 * Timeout used while waiting for Auth0 to mint a token.
 */
export const TOKEN_REQUEST_TIMEOUT_IN_MS = 12000;

/**
 * Timeout used while waiting for the current-user bootstrap request.
 */
export const CURRENT_USER_TIMEOUT_IN_MS = 12000;

/**
 * Max attempts for token bootstrap retries.
 */
export const AUTH_RETRY_ATTEMPTS = 3;

/**
 * Max attempts for current-user bootstrap retries.
 */
export const CURRENT_USER_RETRY_ATTEMPTS = 3;

/**
 * Max attempts for the first-login permissions refresh window.
 */
export const PERMISSIONS_REFRESH_ATTEMPTS = 5;

/**
 * Base retry delay used by auth bootstrap backoff.
 */
export const BASE_RETRY_DELAY_IN_MS = 1000;

/**
 * Backend error code returned after an alternate Auth0 identity is linked.
 * This local adapter constant mirrors the legacy HTTP error contract until the
 * shared API packages expose typed authentication error codes.
 */
export const IDENTITY_LINKED_REAUTHENTICATION_REQUIRED =
  'identity_linked_reauthentication_required';

/**
 * Backend error code returned when an alternate identity cannot be linked
 * safely and must not receive local user or tenant context.
 */
export const IDENTITY_LINKING_MANUAL_RECOVERY_REQUIRED =
  'identity_linking_manual_recovery_required';
